import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableHeader } from '../../PHPComponents/TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { selectTrimInwReg } from '../Selectors/StitchSelector/StitchingSelectors';
import { TrimmingMenu } from '../TitleList';
import { fetchTrimInwReg } from '../../Store/PHPSlice/Trimming/TrimApi';
import TableInwbody from './table-inwbody';


const TrimInwReg = () => {
    const dispatch = useDispatch();
    const trimlist = useSelector(selectTrimInwReg);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);


    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchTrimInwReg());
    }, [dispatch]);


    const compData = Array.isArray(trimlist?.data) ? trimlist?.data?.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            dt: item.dt,
            trMemo: item.trMemo,
            trId: item.trId,
            trnMemo: item.trnMemo,
            firmId: item.firmId,
            firmNm: item.firmNm,
            soId: item.soId,
            sono: item.sono,
            orderno: item.orderno,
            empId: item.empId,
            empNm: item.empNm,
            itemId: item.itemId,
            itemNm: item.itemNm,
            totqty: item.totqty,
            inwqty: item.inwqty,
            sts: item.sts,
            psts: item.psts
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.dt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.trMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.empNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.orderno?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.sono?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    // const notFound = !dataFiltered.length;
    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={TrimmingMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Trimming Inward Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'firmNm', label: 'Firm' },
                                                { id: 'trMemo', label: 'Trimming Memo' },
                                                // { id: 'trnMemo', label: 'Trimming Inward Memo' },
                                                { id: 'sono', label: 'SO No.' },
                                                { id: 'orderno', label: 'Order No.' },
                                                { id: 'empNm', label: 'Master' },
                                                { id: 'itemNm', label: 'Item' },
                                                { id: 'totqty', label: 'Total Issue Qty.' },
                                                { id: 'inwqty', label: 'Total Inward Qty.' },
                                                { id: '', label: 'View' },
                                                // { id: '', label: 'Edit' },
                                                { id: '', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableInwbody
                                                key={row.srno}
                                                id={row.srno}
                                                dt={row.dt}
                                                trMemo={row.trMemo}
                                                trId={row.trId}
                                                trnMemo={row.trnMemo}
                                                firmId={row.firmId}
                                                firmNm={row.firmNm}
                                                soId={row.soId}
                                                sono={row.sono}
                                                empId={row.empId}
                                                empNm={row.empNm}
                                                itemId={row.itemId}
                                                itemNm={row.itemNm}
                                                totqty={row.totqty}
                                                inwqty={row.inwqty}
                                                orderno={row.orderno}
                                                sts={row.sts}
                                                psts={row.psts}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default TrimInwReg;
